function n(e) {
  return Object.keys(e);
}
const l = {
  "aI/errorBackground": "#fff4f5",
  "aI/errorDetailBackground": "#ffffff99",
  "aI/errorText": "#ed3f3f",
  "aI/thinkingOutputBackground": "#f9f9f9",
  "aI/thinkingOutputText": "#000000a6",
  "aI/userTextBackground": "#f3f3f3",
  "adjustmentHandle/background": "#00000038",
  "backlinks/blockBackgroundColor": "#9292920d",
  "backlinks/blockBorder": "#9292921a",
  "backlinks/blockHover": "#0000000d",
  "badge/believer": "#002742",
  "badge/free": "#29a3fa",
  "badge/pro": "#29a3fa",
  "block/callout/background/blue": "#f0f9ff",
  "block/callout/background/green": "#fbfef1",
  "block/callout/background/grey": "#f9f9f9",
  "block/callout/background/magenta": "#fefaff",
  "block/callout/background/orange": "#fff7ee",
  "block/callout/background/purple": "#f9f7ff",
  "block/callout/background/red": "#fff4f5",
  "block/callout/background/teal": "#eefffd",
  "block/callout/background/yellow": "#fdfcf4",
  "block/callout/icon/blue": "#53b2ef",
  "block/callout/icon/green": "#22bf07",
  "block/callout/icon/grey": "#cdcdcd",
  "block/callout/icon/magenta": "#cc4187",
  "block/callout/icon/orange": "#ffae63",
  "block/callout/icon/purple": "#7c3aed",
  "block/callout/icon/red": "#c83030",
  "block/callout/icon/teal": "#448e86",
  "block/callout/icon/yellow": "#fde047",
  "block/divider/divider": "#92929238",
  "block/footnote/numberBg": "#e6e6e6",
  "block/footnote/numberBgHover": "#1e96eb",
  "block/list/header": "#0077cb",
  "block/notSupportedBlock/background": "#ffffff",
  "block/notSupportedBlock/inlineBg/default": "#f3f3f3",
  "block/notSupportedBlock/inlineBg/hover": "#e6e6e6",
  "block/recordBlock/buttonBg": "#f3f3f3",
  "block/recordBlock/primary": "#f45353",
  "block/recordBlock/secordary": "#ff9a9a",
  "block/recordBlock/timelineIndeicator": "#ed3f3f",
  "button/badgesColor": "#ed3f3f",
  "button/buttonOverHover": "#ffffff",
  "button/checkBox": "#1e96eb",
  "button/disable": "#b3b3b3",
  "button/emptyIconBackground": "#0000000d",
  "button/error": "#ed3f3f",
  "button/iconButtonSolid": "#ffffff",
  "button/innerBlackBorder": "#0000001a",
  "button/primary": "#1e96eb",
  "button/pureWhiteText": "#ffffff",
  "button/secondary": "#ffffff",
  "button/success": "#44b931",
  "button/templateLabelBackground": "#1e96eb0a",
  "button/grabber/select": "#00000038",
  "button/grabber/default": "#0000001a",
  "button/mobile/aIActionBackground": "#252525",
  "button/mobile/deletedAction": "#ed3f3f",
  "button/sidebarButton/background": "#ffffff08",
  "button/siderbarPrimary/background": "#ffffffab",
  "button/signinbutton/background": "#ffffff",
  "calendar/blue": "#4ab1fa",
  "calendar/green": "#44b931",
  "calendar/grey": "#b3b3b3",
  "calendar/magenta": "#f37fba",
  "calendar/orange": "#ffae63",
  "calendar/purple": "#9681ef",
  "calendar/red": "#f43f48",
  "calendar/teal": "#8be7dc",
  "calendar/yellow": "#fde047",
  "centerPeek/background": "#ffffff",
  "centerPeek/buttonBackground": "#ffffff",
  "centerPeek/icon": "#7a7a7a",
  "centerPeek/overlay": "#0000002b",
  "chatBlock/chatBlockBg": "#ffffff",
  "chatBlock/chatBlockBoder": "#e6e6e6",
  "chatBlock/chatBlockIcon": "#7a7a7a",
  "chatBlock/chatBlockText": "#141414",
  "chip/label/blue": "#e6f5ff",
  "chip/label/green": "#dcfdd7",
  "chip/label/grey": "#e6e6e6",
  "chip/label/magenta": "#ffecf6",
  "chip/label/orange": "#ffebd5",
  "chip/label/purple": "#ede9ff",
  "chip/label/red": "#fce5e6",
  "chip/label/teal": "#d7fbf6",
  "chip/label/text": "#00000085",
  "chip/label/white": "#f5f5f5",
  "chip/label/yellow": "#fef3c7",
  "chip/tag/blue": "#84cfff",
  "chip/tag/green": "#69b87d",
  "chip/tag/grey": "#b3b3b3",
  "chip/tag/orange": "#ff8c38",
  "chip/tag/purple": "#7c3aed",
  "chip/tag/red": "#ed3f3f",
  "chip/tag/teal": "#8be7dc",
  "chip/tag/yellow": "#facc15",
  "database/border": "#0000001a",
  "database/buttonBackground": "#ffffff",
  "database/cardHover": "#00000008",
  "database/filterHeaderFadeIn": "#ffffff",
  "database/filterHeaderFadeOut": "#ffffff08",
  "database/focusBackground": "#1e96eb0a",
  "database/textSecondary": "#00000085",
  "database/attachment/fileSolidBackground": "#e6e6e6",
  "dialog/background/primary": "#ffffff",
  "edgeless/alignment/edgeGuides": "#cc4187",
  "edgeless/alignment/guides": "#8b5cf6",
  "edgeless/frame/background/black": "#cdcdcd",
  "edgeless/frame/background/blue": "#e6f5ff",
  "edgeless/frame/background/green": "#f1fdf4",
  "edgeless/frame/background/grey": "#f3f3f3",
  "edgeless/frame/background/magenta": "#ffecf6",
  "edgeless/frame/background/orange": "#ffebd5",
  "edgeless/frame/background/purple": "#ede9ff",
  "edgeless/frame/background/red": "#fce5e6",
  "edgeless/frame/background/teal": "#e2fdf9",
  "edgeless/frame/background/white": "#ffffff",
  "edgeless/frame/background/yellow": "#fffbd5",
  "edgeless/frame/border/active": "#1e96eb",
  "edgeless/frame/border/default": "#0000002b",
  "edgeless/frame/fontColor/font": "#000000f2",
  "edgeless/group/background/background": "#ffffff",
  "edgeless/group/border/active": "#1e96eb",
  "edgeless/group/border/borderHint": "#8fd1ff",
  "edgeless/group/border/hover": "#1e96eb",
  "edgeless/group/fontColor/active": "#1e96eb",
  "edgeless/group/fontColor/default": "#00000085",
  "edgeless/group/fontColor/hover": "#1e96eb",
  "edgeless/group/fontColor/rename": "#000000",
  "edgeless/line/black": "#000000",
  "edgeless/line/blue": "#29a3fa",
  "edgeless/line/green": "#3cbc36",
  "edgeless/line/grey": "#929292",
  "edgeless/line/magenta": "#e660a4",
  "edgeless/line/orange": "#ff8c38",
  "edgeless/line/purple": "#6e52df",
  "edgeless/line/red": "#e11e41",
  "edgeless/line/teal": "#5cc7ba",
  "edgeless/line/white": "#ffffff",
  "edgeless/line/yellow": "#facc15",
  "edgeless/lock/locked": "#92929285",
  "edgeless/mindMap/line": "#000000",
  "edgeless/note/black": "#b3b3b3",
  "edgeless/note/blue": "#ceecff",
  "edgeless/note/green": "#c9f8c1",
  "edgeless/note/grey": "#e6e6e6",
  "edgeless/note/magenta": "#ffdaed",
  "edgeless/note/orange": "#ffc58f",
  "edgeless/note/purple": "#ddd6fe",
  "edgeless/note/red": "#fbb7b7",
  "edgeless/note/teal": "#c7f8f2",
  "edgeless/note/white": "#ffffff",
  "edgeless/note/yellow": "#fde68a",
  "edgeless/palette/black": "#000000",
  "edgeless/palette/white": "#ffffff",
  "edgeless/palette/heavy/blue": "#1c70a5",
  "edgeless/palette/heavy/green": "#447756",
  "edgeless/palette/heavy/magenta": "#941555",
  "edgeless/palette/heavy/orange": "#b55309",
  "edgeless/palette/heavy/purple": "#5a21b6",
  "edgeless/palette/heavy/red": "#761717",
  "edgeless/palette/heavy/yellow": "#ac7400",
  "edgeless/palette/light/blueLight": "#e6f5ff",
  "edgeless/palette/light/greenLight": "#f1fdf4",
  "edgeless/palette/light/greyLight": "#e6e6e6",
  "edgeless/palette/light/magentaLight": "#ffecf6",
  "edgeless/palette/light/orangeLight": "#ffebd5",
  "edgeless/palette/light/purpleLight": "#ede9ff",
  "edgeless/palette/light/redLight": "#fce5e6",
  "edgeless/palette/light/yellowLight": "#fffbd5",
  "edgeless/palette/medium/blueMedium": "#84cfff",
  "edgeless/palette/medium/greenMedium": "#3cbc36",
  "edgeless/palette/medium/greyMedium": "#929292",
  "edgeless/palette/medium/magentaMedium": "#e96cab",
  "edgeless/palette/medium/orangeMedium": "#ff8c38",
  "edgeless/palette/medium/purpleMedium": "#6e52df",
  "edgeless/palette/medium/redMedium": "#fb7081",
  "edgeless/palette/medium/yellowMedium": "#fcd34d",
  "edgeless/selection/selectionMarqueeBackground": "#1e96eb14",
  "edgeless/selection/selectionMarqueeBorder": "#1e96eb",
  "edgeless/shape/black": "#000000",
  "edgeless/shape/blue": "#9fd9ff",
  "edgeless/shape/green": "#9bda91",
  "edgeless/shape/grey": "#cdcdcd",
  "edgeless/shape/magenta": "#ffc0e0",
  "edgeless/shape/orange": "#ffae63",
  "edgeless/shape/purple": "#d7cdff",
  "edgeless/shape/red": "#fecdd1",
  "edgeless/shape/teal": "#8be7dc",
  "edgeless/shape/white": "#ffffff",
  "edgeless/shape/yellow": "#fde047",
  "edgelessToolbar/highlightPen/body": "#fafafa",
  "edgelessToolbar/highlightPen/body1Linear1-1": "#00000000",
  "edgelessToolbar/highlightPen/body1Linear1-2": "#00000000",
  "edgelessToolbar/highlightPen/body1Linear1-3": "#000000",
  "edgelessToolbar/highlightPen/body1Linear2-1": "#ffffff00",
  "edgelessToolbar/highlightPen/body1Linear2-2": "#ffffff00",
  "edgelessToolbar/highlightPen/body1Linear2-3": "#ffffff00",
  "edgelessToolbar/highlightPen/body1Linear2-4": "#ffffff00",
  "edgelessToolbar/highlightPen/body2": "#f3f3f3",
  "edgelessToolbar/highlightPen/body2Linear1-1": "#00000000",
  "edgelessToolbar/highlightPen/body2Linear1-2": "#00000000",
  "edgelessToolbar/highlightPen/body2Linear1-3": "#000000",
  "edgelessToolbar/highlightPen/body2Linear2-1": "#00000000",
  "edgelessToolbar/highlightPen/body2Linear2-2": "#00000000",
  "edgelessToolbar/highlightPen/body2Linear2-3": "#00000000",
  "edgelessToolbar/highlightPen/body2Linear2-4": "#00000000",
  "edgelessToolbar/highlightPen/body2Linear2-5": "#00000000",
  "edgelessToolbar/highlightPen/bodyColorLinear-1": "#00000000",
  "edgelessToolbar/highlightPen/bodyColorLinear-2": "#000000fc",
  "edgelessToolbar/highlightPen/bodyColorLinear-3": "#000000c4",
  "edgelessToolbar/media/whiteVector": "#ffffff8f",
  "edgelessToolbar/note/background": "#ffffff",
  "edgelessToolbar/note/textColor": "#0000001a",
  "edgelessToolbar/others/background": "#ffffff1f",
  "edgelessToolbar/others/highlightLinearEnd": "#ffffff",
  "edgelessToolbar/others/highlightLinearStart": "#ffffff00",
  "edgelessToolbar/others/linearCenter": "#000000c4",
  "edgelessToolbar/others/linearEnd": "#0000001f",
  "edgelessToolbar/others/linearStart": "#ffffff1f",
  "edgelessToolbar/penEraser/eraserBlue-1": "#173654",
  "edgelessToolbar/penEraser/eraserBlue-2": "#effaff",
  "edgelessToolbar/penEraser/eraserBlue-3": "#1e96eb",
  "edgelessToolbar/penEraser/eraserBodyFill": "#f1f1f1",
  "edgelessToolbar/penEraser/eraserBodyHighlight": "#ffffff8f",
  "edgelessToolbar/penEraser/eraserBodyShade2": "#00000033",
  "edgelessToolbar/penEraser/eraserBodyShade3": "#ffffff",
  "edgelessToolbar/penEraser/eraserBorder": "#e7e7e7",
  "edgelessToolbar/penEraser/eraserBorder2": "#e3e2e4",
  "edgelessToolbar/penEraser/eraserClothHighlight": "#ffffff1c",
  "edgelessToolbar/penEraser/eraserClothShade2": "#0f0f0f",
  "edgelessToolbar/penEraser/eraserClothShade3": "#ffffff17",
  "edgelessToolbar/penEraser/eraserShadow": "#00000040",
  "edgelessToolbar/penEraser/penBackground": "#fafafa",
  "edgelessToolbar/penEraser/penBodyShade-1": "#00000033",
  "edgelessToolbar/penEraser/penBodyShade-2": "#0000001a",
  "edgelessToolbar/penEraser/penBodyShade-3": "#00000003",
  "edgelessToolbar/penEraser/penBodyShade-4": "#ffffff14",
  "edgelessToolbar/penEraser/penInlineShadow": "#ffffff00",
  "icon/activated": "#1e96eb",
  "icon/disable": "#b3b3b3",
  "icon/fileIconBorder": "#cdcdcd",
  "icon/primary": "#7a7a7a",
  "icon/secondary": "#b3b3b3",
  "icon/tertiary": "#cdcdcd",
  "icon/transparentBlack": "#00000085",
  "icon/fileIconColors/blue": "#0077cb",
  "icon/fileIconColors/green": "#1d9c07",
  "icon/fileIconColors/grey": "#1e1b4b",
  "icon/fileIconColors/magenta": "#e660a4",
  "icon/fileIconColors/purple": "#6e52df",
  "icon/fileIconColors/red": "#ed3f3f",
  "icon/fileIconColors/yellow": "#facc15",
  "input/background": "#ffffff",
  "input/scrollBar/handle": "#0000001a",
  "input/border/active": "#1e96eb",
  "input/border/default": "#0000001a",
  "input/border/error": "#ed3f3f",
  "integrations/background/iconSolid": "#ffffff",
  "layer/black": "#000000",
  "layer/pureBlack": "#000000",
  "layer/pureWhite": "#ffffff",
  "layer/white": "#ffffff",
  "layer/insideBorder/blackBorder": "#0000001a",
  "layer/insideBorder/border": "#e6e6e6",
  "layer/insideBorder/primaryBorder": "#1e96eb",
  "layer/insideBorder/splitviewActived": "#0000002b",
  "layer/insideBorder/whiteBorder": "#ffffff8f",
  "layer/background/codeBlock": "#f9f9f9",
  "layer/background/error": "#fff1f1",
  "layer/background/hoverOverlay": "#0000000d",
  "layer/background/modal": "#000000b2",
  "layer/background/modalWhite": "#ffffff2b",
  "layer/background/overlayPanel": "#ffffff",
  "layer/background/primary": "#ffffff",
  "layer/background/processing": "#eef2ff",
  "layer/background/secondary": "#f5f5f5",
  "layer/background/success": "#f1fdf4",
  "layer/background/tertiary": "#f3f3f3",
  "layer/background/translucentUI": "#ffffffb8",
  "layer/background/warning": "#fff7ee",
  "layer/background/mobile/iOSControl": "#000000",
  "layer/background/mobile/modal": "#0000002b",
  "layer/background/mobile/primary": "#f5f5f5",
  "layer/background/mobile/secondary": "#ffffff",
  "layer/background/mobile/tertiary": "#e6e6e6",
  "loading/background": "#0000001a",
  "loading/foreground": "#1e96eb",
  "others/warnLabel/black": "#000000",
  "others/warnLabel/yellow": "#facc15",
  "portrait/localPortrait": "#00000038",
  "portrait/localPortraitBackground": "#0000001a",
  "radio/disable": "#cdcdcd",
  "radio/active/chekced": "#1e96eb",
  "radio/active/default": "#7a7a7a",
  "readwise/quoteBackground": "#f9f9f9",
  "readwise/quoteDivider": "#1e96eb",
  "segment/background": "#0000000d",
  "segment/button": "#ffffff",
  "selfhost/portrait/localPortraitBackground": "#0000000d",
  "selfhost/button/disable": "#7a7a7a",
  "selfhost/button/primary": "#141414",
  "selfhost/button/secondary": "#ffffff",
  "selfhost/button/sidebarButton/bg/hover": "#0000000d",
  "selfhost/button/sidebarButton/bg/select": "#0000000d",
  "selfhost/icon/buttonIcon": "#ffffff",
  "selfhost/icon/buttonIconError": "#ffffff",
  "selfhost/icon/disable": "#b3b3b3",
  "selfhost/icon/primary": "#141414",
  "selfhost/icon/secondary": "#7a7a7a",
  "selfhost/icon/tertiary": "#b3b3b3",
  "selfhost/layer/background/hoverOverlay": "#ffffff3b",
  "selfhost/layer/background/primary": "#ffffff",
  "selfhost/layer/background/secondary": "#f9f9f9",
  "selfhost/layer/background/sidebarBg/sidebarBg": "#f9f9f9",
  "selfhost/layer/border/border": "#141414",
  "selfhost/progress/error": "#ed3f3f",
  "selfhost/progress/primary": "#141414",
  "selfhost/text/placeholder": "#b3b3b3",
  "selfhost/text/button/error": "#ffffff",
  "selfhost/text/button/primary": "#ffffff",
  "selfhost/text/sidebar/primary": "#141414",
  "selfhost/text/sidebar/secondary": "#252525",
  "selfhost/toggle/backgroundDisable": "#e6e6e6",
  "selfhost/toggle/backgroundOff": "#cdcdcd",
  "selfhost/toggle/backgroundOn": "#141414",
  "selfhost/toggle/foreground": "#ffffff",
  "selfhost/toggle/foregroundDisable": "#f9f9f9",
  "skeleton/skeleton": "#e6e6e6",
  "slashMenu/background": "#ffffff",
  "status/error": "#ed3f3f",
  "status/success": "#44b931",
  "switch/buttonBackground/active": "#ffffff",
  "switch/buttonBackground/hover": "#0000000d",
  "switch/fontColor/primary": "#141414",
  "switch/fontColor/secondary": "#7a7a7a",
  "switch/fontColor/tertiary": "#929292",
  "switch/iconColor/active": "#565656",
  "switch/iconColor/default": "#929292",
  "switch/switchBackground/background": "#f3f3f3",
  "tab/divider/divider": "#00000012",
  "tab/divider/indicator": "#1e96eb",
  "tab/fontColor/active": "#141414",
  "tab/fontColor/default": "#b3b3b3",
  "tab/fontColor/hover": "#141414",
  "tab/iconColor/active": "#565656",
  "tab/iconColor/default": "#b3b3b3",
  "tab/iconColor/hover": "#565656",
  "tab/tabBackground/active": "#ffffff",
  "tab/tabBackground/default": "#f3f3f3",
  "tab/tabBackground/hover": "#f3f3f3",
  "table/border": "#0000001a",
  "table/focusBackground": "#1e96eb0a",
  "table/focusBorder": "#1e96eb",
  "table/textSecondary": "#00000085",
  "table/headerBackground/blue": "#f0f9ff",
  "table/headerBackground/default": "#ffffff",
  "table/headerBackground/green": "#efffec",
  "table/headerBackground/grey": "#f5f5f5",
  "table/headerBackground/headerColor": "#f3f3f3",
  "table/headerBackground/orange": "#fff7ee",
  "table/headerBackground/purple": "#f7f5ff",
  "table/headerBackground/red": "#fff4f5",
  "table/headerBackground/teal": "#eefffd",
  "table/headerBackground/yellow": "#fffded",
  "table/indicator/activated": "#1e96eb",
  "table/indicator/border": "#e6e6e6",
  "table/indicator/drag": "#0000002b",
  "table/indicator/hover": "#0000000d",
  "table/indicator/pointerActive": "#ffffff",
  "table/indicator/pointerDefault": "#b3b3b3",
  "text/disable": "#7a7a7a",
  "text/emphasis": "#1e96eb",
  "text/link": "#035f9f",
  "text/listDotAndNumber": "#0077cb",
  "text/placeholder": "#929292",
  "text/primary": "#141414",
  "text/pureWhite": "#ffffff",
  "text/secondary": "#7a7a7a",
  "text/tertiary": "#929292",
  "text/highlight/border": "#00000038",
  "text/highlight/bg/blue": "#daf0ff",
  "text/highlight/bg/green": "#f0fccb",
  "text/highlight/bg/grey": "#e6e6e6",
  "text/highlight/bg/magenta": "#ffecf6",
  "text/highlight/bg/orange": "#ffebd5",
  "text/highlight/bg/purple": "#ede9ff",
  "text/highlight/bg/red": "#fce5e6",
  "text/highlight/bg/teal": "#c7f8f2",
  "text/highlight/bg/yellow": "#fff9b6",
  "text/highlight/fg/blue": "#003c67",
  "text/highlight/fg/green": "#225c18",
  "text/highlight/fg/grey": "#7a7a7a",
  "text/highlight/fg/magenta": "#941555",
  "text/highlight/fg/orange": "#db7123",
  "text/highlight/fg/purple": "#7c3aed",
  "text/highlight/fg/red": "#c83030",
  "text/highlight/fg/teal": "#0e4841",
  "text/highlight/fg/yellow": "#ac7400",
  "toast/cardLayer/second": "#f9f9f9",
  "toast/cardLayer/third": "#f5f5f5",
  "toast/iconState/error": "#ed3f3f",
  "toast/iconState/regular": "#0077cb",
  "toast/iconState/success": "#44b931",
  "toast/overlay/secondary": "#00000008",
  "toast/overlay/tertiary": "#0000000d",
  "toggle/background": "#1e96eb",
  "toggle/backgroundDisable": "#b3b3b3",
  "toggle/backgroundOff": "#929292",
  "toggle/foreground": "#ffffff",
  "toggle/foregroundDisable": "#e6e6e6",
  "tooltips/background": "#000000",
  "tooltips/foreground": "#ffffff",
  "tooltips/secondaryBackground": "#ffffff2b",
  "workspacePicker/border": "#e6e6e6",
  "workspacePicker/secondaryBackground": "#9292921a",
  "tableOfContent/background": "#ffffff"
}, c = {
  "aI/errorBackground": "#ed3f3f2e",
  "aI/errorDetailBackground": "#00000054",
  "aI/errorText": "#fff4f5",
  "aI/thinkingOutputBackground": "#000000",
  "aI/thinkingOutputText": "#ffffff8f",
  "aI/userTextBackground": "#252525",
  "adjustmentHandle/background": "#ffffff8f",
  "backlinks/blockBackgroundColor": "#9292921a",
  "backlinks/blockBorder": "#9292922b",
  "backlinks/blockHover": "#9292922b",
  "badge/believer": "#002742",
  "badge/free": "#29a3fa",
  "badge/pro": "#29a3fa",
  "block/callout/background/blue": "#002742",
  "block/callout/background/green": "#192e06",
  "block/callout/background/grey": "#414141",
  "block/callout/background/magenta": "#5f0a35",
  "block/callout/background/orange": "#451a02",
  "block/callout/background/purple": "#1e1b4b",
  "block/callout/background/red": "#460606",
  "block/callout/background/teal": "#0e4841",
  "block/callout/background/yellow": "#321a04",
  "block/callout/icon/blue": "#2f94d5",
  "block/callout/icon/green": "#22bf07",
  "block/callout/icon/grey": "#cdcdcd",
  "block/callout/icon/magenta": "#cc4187",
  "block/callout/icon/orange": "#d97705",
  "block/callout/icon/purple": "#7c3aed",
  "block/callout/icon/red": "#c83030",
  "block/callout/icon/teal": "#5cc7ba",
  "block/callout/icon/yellow": "#e0aa00",
  "block/divider/divider": "#9292922b",
  "block/footnote/numberBg": "#565656",
  "block/footnote/numberBgHover": "#1e96eb",
  "block/list/header": "#4ab1fa",
  "block/notSupportedBlock/background": "#000000",
  "block/notSupportedBlock/inlineBg/default": "#252525",
  "block/notSupportedBlock/inlineBg/hover": "#414141",
  "block/recordBlock/buttonBg": "#761717",
  "block/recordBlock/primary": "#f45353",
  "block/recordBlock/secordary": "#c83030",
  "block/recordBlock/timelineIndeicator": "#ed3f3f",
  "button/badgesColor": "#c83030",
  "button/buttonOverHover": "#414141",
  "button/checkBox": "#1e96eb",
  "button/disable": "#7a7a7a",
  "button/emptyIconBackground": "#ffffff0d",
  "button/error": "#c83030",
  "button/iconButtonSolid": "#ffffff17",
  "button/innerBlackBorder": "#ffffff0d",
  "button/primary": "#1e96eb",
  "button/pureWhiteText": "#ffffff",
  "button/secondary": "#ffffff17",
  "button/success": "#1d9c07",
  "button/templateLabelBackground": "#1e96eb14",
  "button/grabber/select": "#ffffff21",
  "button/grabber/default": "#ffffff17",
  "button/mobile/aIActionBackground": "#252525",
  "button/mobile/deletedAction": "#c83030",
  "button/sidebarButton/background": "#ffffff08",
  "button/siderbarPrimary/background": "#0000002b",
  "button/signinbutton/background": "#414141",
  "calendar/blue": "#29a3fa",
  "calendar/green": "#3cbc36",
  "calendar/grey": "#929292",
  "calendar/magenta": "#e660a4",
  "calendar/orange": "#ff8c38",
  "calendar/purple": "#6e52df",
  "calendar/red": "#ed3f3f",
  "calendar/teal": "#5cc7ba",
  "calendar/yellow": "#facc15",
  "centerPeek/background": "#000000",
  "centerPeek/buttonBackground": "#252525",
  "centerPeek/icon": "#cdcdcd",
  "centerPeek/overlay": "#00000085",
  "chatBlock/chatBlockBg": "#252525",
  "chatBlock/chatBlockBoder": "#414141",
  "chatBlock/chatBlockIcon": "#cdcdcd",
  "chatBlock/chatBlockText": "#e6e6e6",
  "chip/label/blue": "#004b7b",
  "chip/label/green": "#225c18",
  "chip/label/grey": "#414141",
  "chip/label/magenta": "#5f0a35",
  "chip/label/orange": "#843b06",
  "chip/label/purple": "#25136d",
  "chip/label/red": "#460606",
  "chip/label/teal": "#1c6b63",
  "chip/label/text": "#ffffffab",
  "chip/label/white": "#252525",
  "chip/label/yellow": "#ac7400",
  "chip/tag/blue": "#84cfff",
  "chip/tag/green": "#69b87d",
  "chip/tag/grey": "#b3b3b3",
  "chip/tag/orange": "#ff8c38",
  "chip/tag/purple": "#7c3aed",
  "chip/tag/red": "#ed3f3f",
  "chip/tag/teal": "#8be7dc",
  "chip/tag/yellow": "#facc15",
  "database/border": "#ffffff21",
  "database/buttonBackground": "#414141",
  "database/cardHover": "#ffffff08",
  "database/filterHeaderFadeIn": "#000000",
  "database/filterHeaderFadeOut": "#00000008",
  "database/focusBackground": "#1e96eb0a",
  "database/textSecondary": "#ffffff8f",
  "database/attachment/fileSolidBackground": "#414141",
  "dialog/background/primary": "#252525",
  "edgeless/alignment/edgeGuides": "#e660a4",
  "edgeless/alignment/guides": "#8b5cf6",
  "edgeless/frame/background/black": "#cdcdcd",
  "edgeless/frame/background/blue": "#e6f5ff",
  "edgeless/frame/background/green": "#f1fdf4",
  "edgeless/frame/background/grey": "#f3f3f3",
  "edgeless/frame/background/magenta": "#ffecf6",
  "edgeless/frame/background/orange": "#ffebd5",
  "edgeless/frame/background/purple": "#ede9ff",
  "edgeless/frame/background/red": "#fce5e6",
  "edgeless/frame/background/teal": "#e2fdf9",
  "edgeless/frame/background/white": "#ffffff",
  "edgeless/frame/background/yellow": "#fffbd5",
  "edgeless/frame/border/active": "#1e96eb",
  "edgeless/frame/border/default": "#ffffff2b",
  "edgeless/frame/fontColor/font": "#000000f2",
  "edgeless/group/background/background": "#ffffff",
  "edgeless/group/border/active": "#1e96eb",
  "edgeless/group/border/borderHint": "#8fd1ff",
  "edgeless/group/border/hover": "#1e96eb",
  "edgeless/group/fontColor/active": "#1e96eb",
  "edgeless/group/fontColor/default": "#ffffff8f",
  "edgeless/group/fontColor/hover": "#1e96eb",
  "edgeless/group/fontColor/rename": "#000000",
  "edgeless/line/black": "#000000",
  "edgeless/line/blue": "#29a3fa",
  "edgeless/line/green": "#3cbc36",
  "edgeless/line/grey": "#929292",
  "edgeless/line/magenta": "#e660a4",
  "edgeless/line/orange": "#ff8c38",
  "edgeless/line/purple": "#6e52df",
  "edgeless/line/red": "#ed3f3f",
  "edgeless/line/teal": "#5cc7ba",
  "edgeless/line/white": "#ffffff",
  "edgeless/line/yellow": "#facc15",
  "edgeless/lock/locked": "#92929285",
  "edgeless/mindMap/line": "#ffffff",
  "edgeless/note/black": "#252525",
  "edgeless/note/blue": "#004b7b",
  "edgeless/note/green": "#3b5315",
  "edgeless/note/grey": "#565656",
  "edgeless/note/magenta": "#5f0a35",
  "edgeless/note/orange": "#843b06",
  "edgeless/note/purple": "#312e81",
  "edgeless/note/red": "#460606",
  "edgeless/note/teal": "#0e4841",
  "edgeless/note/white": "#000000",
  "edgeless/note/yellow": "#704200",
  "edgeless/palette/black": "#ffffff",
  "edgeless/palette/white": "#000000",
  "edgeless/palette/heavy/blue": "#1c70a5",
  "edgeless/palette/heavy/green": "#447756",
  "edgeless/palette/heavy/magenta": "#941555",
  "edgeless/palette/heavy/orange": "#b55309",
  "edgeless/palette/heavy/purple": "#5a21b6",
  "edgeless/palette/heavy/red": "#761717",
  "edgeless/palette/heavy/yellow": "#ac7400",
  "edgeless/palette/light/blueLight": "#e6f5ff",
  "edgeless/palette/light/greenLight": "#f1fdf4",
  "edgeless/palette/light/greyLight": "#e6e6e6",
  "edgeless/palette/light/magentaLight": "#ffecf6",
  "edgeless/palette/light/orangeLight": "#ffebd5",
  "edgeless/palette/light/purpleLight": "#d7cdff",
  "edgeless/palette/light/redLight": "#fce5e6",
  "edgeless/palette/light/yellowLight": "#fffbd5",
  "edgeless/palette/medium/blueMedium": "#84cfff",
  "edgeless/palette/medium/greenMedium": "#3cbc36",
  "edgeless/palette/medium/greyMedium": "#929292",
  "edgeless/palette/medium/magentaMedium": "#e96cab",
  "edgeless/palette/medium/orangeMedium": "#ff8c38",
  "edgeless/palette/medium/purpleMedium": "#6e52df",
  "edgeless/palette/medium/redMedium": "#fb7081",
  "edgeless/palette/medium/yellowMedium": "#fcd34d",
  "edgeless/selection/selectionMarqueeBackground": "#1e96eb14",
  "edgeless/selection/selectionMarqueeBorder": "#1e96eb",
  "edgeless/shape/black": "#000000",
  "edgeless/shape/blue": "#9fd9ff",
  "edgeless/shape/green": "#9bda91",
  "edgeless/shape/grey": "#cdcdcd",
  "edgeless/shape/magenta": "#ffc0e0",
  "edgeless/shape/orange": "#ffae63",
  "edgeless/shape/purple": "#d7cdff",
  "edgeless/shape/red": "#fbb7b7",
  "edgeless/shape/teal": "#8be7dc",
  "edgeless/shape/white": "#ffffff",
  "edgeless/shape/yellow": "#fde047",
  "edgelessToolbar/highlightPen/body": "#3d3d3d",
  "edgelessToolbar/highlightPen/body1Linear1-1": "#00000000",
  "edgelessToolbar/highlightPen/body1Linear1-2": "#00000000",
  "edgelessToolbar/highlightPen/body1Linear1-3": "#000000",
  "edgelessToolbar/highlightPen/body1Linear2-1": "#00000000",
  "edgelessToolbar/highlightPen/body1Linear2-2": "#00000080",
  "edgelessToolbar/highlightPen/body1Linear2-3": "#000000",
  "edgelessToolbar/highlightPen/body1Linear2-4": "#ffffff",
  "edgelessToolbar/highlightPen/body2": "#303030",
  "edgelessToolbar/highlightPen/body2Linear1-1": "#00000000",
  "edgelessToolbar/highlightPen/body2Linear1-2": "#00000000",
  "edgelessToolbar/highlightPen/body2Linear1-3": "#00000000",
  "edgelessToolbar/highlightPen/body2Linear2-1": "#00000000",
  "edgelessToolbar/highlightPen/body2Linear2-2": "#00000000",
  "edgelessToolbar/highlightPen/body2Linear2-3": "#00000000",
  "edgelessToolbar/highlightPen/body2Linear2-4": "#000000",
  "edgelessToolbar/highlightPen/body2Linear2-5": "#797979",
  "edgelessToolbar/highlightPen/bodyColorLinear-1": "#00000000",
  "edgelessToolbar/highlightPen/bodyColorLinear-2": "#000000",
  "edgelessToolbar/highlightPen/bodyColorLinear-3": "#000000c4",
  "edgelessToolbar/media/whiteVector": "#00000038",
  "edgelessToolbar/note/background": "#414141",
  "edgelessToolbar/note/textColor": "#ffffff21",
  "edgelessToolbar/others/background": "#4a4a4ab2",
  "edgelessToolbar/others/highlightLinearEnd": "#ffffff1f",
  "edgelessToolbar/others/highlightLinearStart": "#ffffff0f",
  "edgelessToolbar/others/linearCenter": "#000000a8",
  "edgelessToolbar/others/linearEnd": "#00000000",
  "edgelessToolbar/others/linearStart": "#00000000",
  "edgelessToolbar/penEraser/eraserBlue-1": "#1c3d5d",
  "edgelessToolbar/penEraser/eraserBlue-2": "#a1c5d3",
  "edgelessToolbar/penEraser/eraserBlue-3": "#1a7cc1",
  "edgelessToolbar/penEraser/eraserBodyFill": "#3d3d3d",
  "edgelessToolbar/penEraser/eraserBodyHighlight": "#ffffff17",
  "edgelessToolbar/penEraser/eraserBodyShade2": "#000000cc",
  "edgelessToolbar/penEraser/eraserBodyShade3": "#ffffff66",
  "edgelessToolbar/penEraser/eraserBorder": "#7f7f7f",
  "edgelessToolbar/penEraser/eraserBorder2": "#9b9b9b",
  "edgelessToolbar/penEraser/eraserClothHighlight": "#ffffff1c",
  "edgelessToolbar/penEraser/eraserClothShade2": "#0f0f0f",
  "edgelessToolbar/penEraser/eraserClothShade3": "#ffffff17",
  "edgelessToolbar/penEraser/eraserShadow": "#000000c4",
  "edgelessToolbar/penEraser/penBackground": "#3d3d3d",
  "edgelessToolbar/penEraser/penBodyShade-1": "#00000099",
  "edgelessToolbar/penEraser/penBodyShade-2": "#00000066",
  "edgelessToolbar/penEraser/penBodyShade-3": "#00000033",
  "edgelessToolbar/penEraser/penBodyShade-4": "#0000001a",
  "edgelessToolbar/penEraser/penInlineShadow": "#00000040",
  "icon/activated": "#1e96eb",
  "icon/disable": "#414141",
  "icon/fileIconBorder": "#565656",
  "icon/primary": "#f3f3f3",
  "icon/secondary": "#cdcdcd",
  "icon/tertiary": "#565656",
  "icon/transparentBlack": "#ffffffb8",
  "icon/fileIconColors/blue": "#0077cb",
  "icon/fileIconColors/green": "#1d9c07",
  "icon/fileIconColors/grey": "#312e81",
  "icon/fileIconColors/magenta": "#e660a4",
  "icon/fileIconColors/purple": "#6e52df",
  "icon/fileIconColors/red": "#ed3f3f",
  "icon/fileIconColors/yellow": "#facc15",
  "input/background": "#ffffff17",
  "input/scrollBar/handle": "#ffffff2b",
  "input/border/active": "#1e96eb",
  "input/border/default": "#ffffff0d",
  "input/border/error": "#ed3f3f",
  "integrations/background/iconSolid": "#ffffff",
  "layer/black": "#ffffff",
  "layer/pureBlack": "#000000",
  "layer/pureWhite": "#ffffff",
  "layer/white": "#000000",
  "layer/insideBorder/blackBorder": "#ffffff0d",
  "layer/insideBorder/border": "#414141",
  "layer/insideBorder/primaryBorder": "#1e96eb",
  "layer/insideBorder/splitviewActived": "#ffffffab",
  "layer/insideBorder/whiteBorder": "#ffffff0d",
  "layer/background/codeBlock": "#252525",
  "layer/background/error": "#460606",
  "layer/background/hoverOverlay": "#ffffff17",
  "layer/background/modal": "#00000085",
  "layer/background/modalWhite": "#ffffff2b",
  "layer/background/overlayPanel": "#252525",
  "layer/background/primary": "#141414",
  "layer/background/processing": "#002742",
  "layer/background/secondary": "#252525",
  "layer/background/success": "#1c3027",
  "layer/background/tertiary": "#565656",
  "layer/background/translucentUI": "#000000a6",
  "layer/background/warning": "#321a04",
  "layer/background/mobile/iOSControl": "#ffffff",
  "layer/background/mobile/modal": "#00000085",
  "layer/background/mobile/primary": "#000000",
  "layer/background/mobile/secondary": "#252525",
  "layer/background/mobile/tertiary": "#414141",
  "loading/background": "#ffffff21",
  "loading/foreground": "#0077cb",
  "others/warnLabel/black": "#000000",
  "others/warnLabel/yellow": "#facc15",
  "portrait/localPortrait": "#ffffff3b",
  "portrait/localPortraitBackground": "#ffffff2b",
  "radio/disable": "#7a7a7a",
  "radio/active/chekced": "#1e96eb",
  "radio/active/default": "#b3b3b3",
  "readwise/quoteBackground": "#252525",
  "readwise/quoteDivider": "#1e96eb",
  "segment/background": "#ffffff0d",
  "segment/button": "#ffffff17",
  "selfhost/portrait/localPortraitBackground": "#ffffff21",
  "selfhost/button/disable": "#252525",
  "selfhost/button/primary": "#f3f3f3",
  "selfhost/button/secondary": "#ffffff17",
  "selfhost/button/sidebarButton/bg/hover": "#ffffff17",
  "selfhost/button/sidebarButton/bg/select": "#ffffff17",
  "selfhost/icon/buttonIcon": "#141414",
  "selfhost/icon/buttonIconError": "#ffffff",
  "selfhost/icon/disable": "#565656",
  "selfhost/icon/primary": "#f3f3f3",
  "selfhost/icon/secondary": "#cdcdcd",
  "selfhost/icon/tertiary": "#565656",
  "selfhost/layer/background/hoverOverlay": "#fffffffa",
  "selfhost/layer/background/primary": "#141414",
  "selfhost/layer/background/secondary": "#252525",
  "selfhost/layer/background/sidebarBg/sidebarBg": "#252525",
  "selfhost/layer/border/border": "#e6e6e6",
  "selfhost/progress/error": "#c83030",
  "selfhost/progress/primary": "#e6e6e6",
  "selfhost/text/placeholder": "#7a7a7a",
  "selfhost/text/button/error": "#ffffff",
  "selfhost/text/button/primary": "#141414",
  "selfhost/text/sidebar/primary": "#e6e6e6",
  "selfhost/text/sidebar/secondary": "#cdcdcd",
  "selfhost/toggle/backgroundDisable": "#414141",
  "selfhost/toggle/backgroundOff": "#565656",
  "selfhost/toggle/backgroundOn": "#b3b3b3",
  "selfhost/toggle/foreground": "#fffffffa",
  "selfhost/toggle/foregroundDisable": "#565656",
  "skeleton/skeleton": "#252525",
  "slashMenu/background": "#252525",
  "status/error": "#c83030",
  "status/success": "#1d9c07",
  "switch/buttonBackground/active": "#414141",
  "switch/buttonBackground/hover": "#ffffff0d",
  "switch/fontColor/primary": "#e6e6e6",
  "switch/fontColor/secondary": "#929292",
  "switch/fontColor/tertiary": "#7a7a7a",
  "switch/iconColor/active": "#cdcdcd",
  "switch/iconColor/default": "#7a7a7a",
  "switch/switchBackground/background": "#252525",
  "tab/divider/divider": "#ffffff21",
  "tab/divider/indicator": "#1e96eb",
  "tab/fontColor/active": "#e6e6e6",
  "tab/fontColor/default": "#565656",
  "tab/fontColor/hover": "#e6e6e6",
  "tab/iconColor/active": "#cdcdcd",
  "tab/iconColor/default": "#7a7a7a",
  "tab/iconColor/hover": "#cdcdcd",
  "tab/tabBackground/active": "#414141",
  "tab/tabBackground/default": "#252525",
  "tab/tabBackground/hover": "#252525",
  "table/border": "#ffffff21",
  "table/focusBackground": "#1e96eb0a",
  "table/focusBorder": "#1e96eb",
  "table/textSecondary": "#ffffff8f",
  "table/headerBackground/blue": "#004b7b",
  "table/headerBackground/default": "#252525",
  "table/headerBackground/green": "#10340a",
  "table/headerBackground/grey": "#565656",
  "table/headerBackground/headerColor": "#252525",
  "table/headerBackground/orange": "#843b06",
  "table/headerBackground/purple": "#25136d",
  "table/headerBackground/red": "#460606",
  "table/headerBackground/teal": "#0e4841",
  "table/headerBackground/yellow": "#704200",
  "table/indicator/activated": "#1e96eb",
  "table/indicator/border": "#414141",
  "table/indicator/drag": "#ffffff21",
  "table/indicator/hover": "#ffffff17",
  "table/indicator/pointerActive": "#ffffff",
  "table/indicator/pointerDefault": "#cdcdcd",
  "text/disable": "#565656",
  "text/emphasis": "#29a3fa",
  "text/link": "#7ac8ff",
  "text/listDotAndNumber": "#4ab1fa",
  "text/placeholder": "#7a7a7a",
  "text/primary": "#e6e6e6",
  "text/pureWhite": "#ffffff",
  "text/secondary": "#929292",
  "text/tertiary": "#7a7a7a",
  "text/highlight/border": "#ffffff3b",
  "text/highlight/bg/blue": "#002742",
  "text/highlight/bg/green": "#192e06",
  "text/highlight/bg/grey": "#414141",
  "text/highlight/bg/magenta": "#5f0a35",
  "text/highlight/bg/orange": "#843b06",
  "text/highlight/bg/purple": "#2e1065",
  "text/highlight/bg/red": "#460606",
  "text/highlight/bg/teal": "#0e4841",
  "text/highlight/bg/yellow": "#321a04",
  "text/highlight/fg/blue": "#2f94d5",
  "text/highlight/fg/green": "#9bda91",
  "text/highlight/fg/grey": "#565656",
  "text/highlight/fg/magenta": "#f37fba",
  "text/highlight/fg/orange": "#ffae63",
  "text/highlight/fg/purple": "#9681ef",
  "text/highlight/fg/red": "#fc7979",
  "text/highlight/fg/teal": "#448e86",
  "text/highlight/fg/yellow": "#facc15",
  "toast/cardLayer/second": "#252525",
  "toast/cardLayer/third": "#252525",
  "toast/iconState/error": "#c83030",
  "toast/iconState/regular": "#035f9f",
  "toast/iconState/success": "#1d9c07",
  "toast/overlay/secondary": "#0000000d",
  "toast/overlay/tertiary": "#00000008",
  "toggle/background": "#0077cb",
  "toggle/backgroundDisable": "#414141",
  "toggle/backgroundOff": "#565656",
  "toggle/foreground": "#fffffffa",
  "toggle/foregroundDisable": "#929292",
  "tooltips/background": "#414141",
  "tooltips/foreground": "#ffffff",
  "tooltips/secondaryBackground": "#ffffff2b",
  "workspacePicker/border": "#414141",
  "workspacePicker/secondaryBackground": "#9292922b",
  "tableOfContent/background": "#252525"
};
function t(e) {
  return `--affine-v2-${e.split("/").join("-")}`;
}
function d(e) {
  const a = {};
  return n(e).forEach((o) => {
    a[t(o)] = e[o];
  }), a;
}
const b = d(l), i = d(c);
function f(e, a) {
  return `var(${t(e)}${a ? `, ${a}` : ""})`;
}
function s(e = "") {
  return new Proxy(f, {
    get(a, o) {
      const r = e ? `${e}/${String(o)}` : String(o);
      return typeof l[r] != "string" ? s(r) : f(r);
    },
    apply(a, o, [r, g]) {
      return e ? f(e, r) : f(r, g);
    }
  });
}
const h = s();
export {
  h as cssVarV2,
  i as darkCssVariablesV2,
  c as darkThemeV2,
  b as lightCssVariablesV2,
  l as lightThemeV2,
  t as themeToVar
};
//# sourceMappingURL=index.js.map
